module.exports = __webpack_public_path__ + "img/navbar.44ed1fc2.png";